import './sticky-navigatie.scss'

document.addEventListener('DOMContentLoaded', () => {
    const stickyNavs = document.querySelectorAll('.o-stickyNavigatie');
    if (!stickyNavs.length) return;

    stickyNavs.forEach((nav) => {
        const toggle = nav.querySelector('.o-stickyNavigatie__toggle');
        const menu = nav.querySelector('.o-stickyNavigatie__lijst');

        if (!toggle || !menu) return;

        const label = toggle.querySelector('.o-stickyNavigatie__label');
        const closeLabel = toggle.dataset.close || 'Close';

        // Pair each nav link with its target section (skip links without a target).
        const entries = Array.from(nav.querySelectorAll('.o-stickyNavigatie__item')).map((link) => {
            const id = (link.getAttribute('href') || '').replace(/^#/, '');
            return { link, section: id ? document.getElementById(id) : null };
        });

        // Fallback label (before any section is active) is the button's initial text.
        const defaultLabel = label ? label.textContent.trim() : '';
        let activeLabel = defaultLabel;

        // Collapsed -> show the active page-item's title; open -> show "Close".
        const renderLabel = () => {
            if (label) label.textContent = nav.classList.contains('open') ? closeLabel : activeLabel;
        };

        const setActive = (activeSection) => {
            entries.forEach(({ link, section }) => {
                const isActive = !!section && section === activeSection;
                link.classList.toggle('active', isActive);
                if (isActive) activeLabel = link.textContent.trim();
            });
            renderLabel();
        };

        toggle.addEventListener('click', () => {
            const expanded = menu.getAttribute('aria-expanded') === 'true';
            menu.setAttribute('aria-expanded', String(!expanded));
            toggle.setAttribute('aria-expanded', String(!expanded));
            nav.classList.toggle('open');
            renderLabel();
        });

        // Track the active section with IntersectionObserver so it works regardless of
        // how the page scrolls (window, a scroll container, or a smooth-scroll library) --
        // offsetTop / window.scrollY are unreliable here.
        const sections = entries.map((entry) => entry.section).filter(Boolean);

        if (sections.length && 'IntersectionObserver' in window) {
            let activeSection = sections[0];
            setActive(activeSection);

            const observer = new IntersectionObserver(
                (observed) => {
                    observed.forEach((entry) => {
                        if (entry.isIntersecting) activeSection = entry.target;
                    });
                    setActive(activeSection);
                },
                // Detection band = top third of the viewport.
                { rootMargin: '0px 0px -66% 0px', threshold: 0 }
            );

            sections.forEach((section) => observer.observe(section));
        } else {
            setActive(sections[0]);
        }
    });
});
